import React from "react";

import "./styles/DurationWinRate.css";

export default function DurationWinRate(props) {
  var wins, looses, winPercentage, games;
  const { rangeImage } = props.statsByDuration;
  const { range } = props.statsByDuration;

  if (props.statsByDuration.stats) {
    ({ wins, looses } = props.statsByDuration.stats);
    games = wins + looses;
    winPercentage = `${Math.trunc((wins / games) * 100 * 100) / 100}%`;
  } else {
    games = 0;
    winPercentage = "-";
  }

  return (
    <article className="duration-win-rate">
      <div className="duration-win-rate-line-1">
        <img src={rangeImage} alt={range} title={range} />
        <p>({games})</p>
      </div>
      <div className="duration-win-rate-line-2">
        <p>{winPercentage}</p>
      </div>
    </article>
  );
}
